import { propertyTypes } from "@/services/properties";

const codes = {
  prodottoProperty: "1a",
  piuVersioniProperty: "1b",
  codProdCollegatiProperty: "1c",
  compagniaProperty: "2",
  mercatoProperty: "3",
  canaleProperty: "4",
  distributoriProperty: "5",
  tipologiaProdottoProperty: "6",
  tipologiaSottostantiProperty: "7",
  prodCommercioProperty: "8",
  inizioCommProperty: "9a",
  fineCommProperty: "9b",
  edizioneDIPAggProperty: "10",
  tipologiaPremioProperty: "11",
  durataContrattoProperty: "13",
  durataPianoPagamentoPremiProperty: "15",
  importoMinPremioUnicoProperty: "16",
  importoMaxPremioUnicoProperty: "17",
  importoMinPremioRicAnnuoProperty: "18",
  importoMaxPremioRicAnnuoProperty: "19",
  targetMarketProperty: "20",
  orizzonteTemporaleSuggeritoProperty: "21",
  indicatoreSinteticoRischioProperty: "22",
  reductionInYieldCostiIngressoProperty: "23",
  reductionInYieldCostiUscitaProperty: "24",
  reductionInYieldCostiCorrentiProperty: "25",
  assetAllocationProperty: "26",
  invMinGestioneSeparataProperty: "27a",
  invMaxGestioneSeparataProperty: "27b",
  gestioneSeparataProperty: "28",
  rendimentoGestioneSeparataProperty: "29",
  rendMinGarantitoProperty: "30",
  rendMinGarantitoMisuraProperty: "31",
  presenzaConsolidamentoAnnuoRivalutazioniContrattualiProperty: "32",
  consolidamentoAnnuoRivalutazioniContrattualiProperty: "33",
  fondoUtiliProperty: "34",
  invMinRamoIIIProperty: "35a",
  invMaxRamoIIIProperty: "35b",
  numFondiInterniProperty: "36",
  tipologiaFondiInterniProperty: "37",
  numOICRETFProperty: "38",
  presenzaProtezioneCapitaleProperty: "39",
  protezioneCapitaleProperty: "40",
  opzioniContrattualiTipologiaProperty: "45",
  cedolaProperty: "46",
  decumuloProperty: "47",
  renditaProperty: "48",
  stopLossProperty: "49",
  takeProfitProperty: "50",
  progressiveInvestmentProperty: "51",
  automaticRebalanceProperty: "52",
  downtrendOpportunityProperty: "53",
  lifeCycleProperty: "54",
  altreOpzioniContrattualiProperty: "55",
  garanzieAssicurativeTipologiaProperty: "62",
  maggiorazioneCasoMorteStandardProperty: "63",
  maggiorazioneCasoMorteStandardPrestazioneProperty: "64",
  maggiorazioneCasoMortePerInfortunioProperty: "65",
  maggiorazioneCasoMortePerInfortunioPrestazioneProperty: "66",
  maggiorazioneCasoMortePerIncidenteStradaleProperty: "67",
  maggiorazioneCasoMortePerIncidenteStradalePrestazioneProperty: "68",
  maggiorazioneCasoMortePerMinusvalenzaProperty: "69",
  maggiorazioneCasoMortePerMinusvalenzaPrestazioneProperty: "70",
  TCMStandAloneProperty: "71",
  TCMStandAlonePrestazioneProperty: "72",
  longTermCareProperty: "73",
  longTermCarePrestazioneProperty: "74",
  dreadDiseaseProperty: "75",
  dreadDiseasePrestazioneProperty: "76",
  invaliditaInabilitaProperty: "77",
  invaliditaInabilitaPrestazioneProperty: "78",
  altreGaranzieAssicurativeProperty: "80",
  tipologiaBonusIngressoProperty: "81",
  bonusIngressoProperty: "82",
  tipologiaBonusFedeltaProperty: "83",
  bonusFedeltaProperty: "84",
  speseEmissioneProperty: "85",
  tipologiaCaricamentoPICProperty: "86",
  caricamentoPICProperty: "87",
  tipologiaCaricamentoPACProperty: "88",
  caricamentoPACProperty: "89",
  caricamentoProperty: "90",
  tipologiaCommissioneGestioneSeparataProperty: "91",
  commissioneGestioneSeparataProperty: "92",
  tipologiaCommissioneFondiInterniProperty: "93",
  commissioneFondiInterniAzionariProperty: "94",
  commissioneFondiInterniObbligazionariProperty: "95",
  commissioneFondiInterniBilanciatiProperty: "96",
  commissioneFondiInterniFlessibiliProperty: "97",
  commissioneFondiInterniMonetariProperty: "98",
  commissioneSottostantiFondiInterniProperty: "99",
  tipologiaSpeseGestionePolizzaOICRETFProperty: "100",
  speseGestionePolizzaOICRETFAzionariProperty: "101",
  speseGestionePolizzaOICRETFObbligazionariProperty: "102",
  speseGestionePolizzaOICRETFBilanciatiProperty: "103",
  speseGestionePolizzaOICRETFFlessibiliProperty: "104",
  speseGestionePolizzaOICRETFMonetariProperty: "105",
  commissioneOICRETFProperty: "106",
  applicazioneCommissioniOverperformanceProperty: "107",
  commissioniOverperformanceProperty: "108",
  costoMaggiorazioneCasoMorteStandardProperty: "109a",
  riscattoProperty: "109b",
  applicazioneCommissioniUscitaProperty: "110",
  commissioniUscitaProperty: "111",
  altriCostiProperty: "112",
  retrocessioneCaricamentoProperty: "113",
  retrocessioneGestioneSeparataProperty: "114",
  retrocessioneRamoIIIProperty: "115",
  noteProperty: "116",
  sostenibilitaProperty: "117",
  ramoISFDRProperty: "118",
  ramoITassonomiaUEProperty: "119",
  ramoIAllocazioneAttiviProperty: "120",
  ramoIPAIProperty: "121",
  ramoIIIPresenzaFondiInterniArt8SFDRProperty: "122",
  ramoIIINumFondiInterniArt8SFDRProperty: "123",
  ramoIIIFondiInterniArt8SFDRPercProperty: "124",
  ramoIIITassonomiaUEFondiInterniArt8Property: "125",
  ramoIIIAllocazioneAttiviFondiInterniArt8Property: "126",
  ramoIIIPresenzaFondiInterniArt9SFDRProperty: "127",
  ramoIIINumFondiInterniArt9SFDRProperty: "128",
  ramoIIIFondiInterniArt9SFDRPercProperty: "129",
  ramoIIITassonomiaUEFondiInterniArt9Property: "130",
  ramoIIIAllocazioneAttiviFondiInterniArt9Property: "131",
  ramoIIIPAIFondiInterniProperty: "132",
  ramoIIIPresenzaOICRETFArt8SFDRProperty: "133",
  ramoIIINumOICRETFArt8SFDRProperty: "134",
  ramoIIIOICRETFArt8SFDRPercProperty: "135",
  ramoIIITassonomiaUEOICRETFArt8Property: "136",
  ramoIIIPresenzaOICRETFArt9SFDRProperty: "137",
  ramoIIINumOICRETFArt9SFDRProperty: "138",
  ramoIIIOICRETFArt9SFDRPercProperty: "139",
  ramoIIITassonomiaUEOICRETFArt9Property: "140",
  ramoIIIPAIOICRETFProperty: "141",
};

const properties = {
  prodottoProperty: {
    code: codes.prodottoProperty,
    name: "Prodotto",
    description: "",
    order: 0,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  piuVersioniProperty: {
    code: codes.piuVersioniProperty,
    name: "Più versioni prodotto",
    description: "",
    order: 1,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  codProdCollegatiProperty: {
    code: codes.codProdCollegatiProperty,
    name: "Codice prodotti collegati",
    description: "",
    order: 2,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  compagniaProperty: {
    code: codes.compagniaProperty,
    name: "Compagnia",
    description: "",
    order: 3,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  mercatoProperty: {
    code: codes.mercatoProperty,
    name: "Mercato",
    description: "",
    order: 4,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  canaleProperty: {
    code: codes.canaleProperty,
    name: "Canale",
    description: "",
    order: 5,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  distributoriProperty: {
    code: codes.distributoriProperty,
    name: "Distributori",
    description: "",
    order: 6,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  tipologiaProdottoProperty: {
    code: codes.tipologiaProdottoProperty,
    name: "Tipologia prodotto",
    description: "",
    order: 7,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  tipologiaSottostantiProperty: {
    code: codes.tipologiaSottostantiProperty,
    name: "Tipologia sottostanti",
    description: "",
    order: 8,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  prodCommercioProperty: {
    code: codes.prodCommercioProperty,
    name: "Prodotto in commercio",
    description: "",
    order: 9,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  inizioCommProperty: {
    code: codes.inizioCommProperty,
    name: "Inizio commercializzazione",
    description: "",
    order: 10,
    value: "",
    values: [],
    dateValue: null,
    valueDescription: "",
    type: propertyTypes.DATE,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  fineCommProperty: {
    code: codes.fineCommProperty,
    name: "Fine commercializzazione",
    description: "",
    order: 11,
    value: "",
    values: [],
    dateValue: null,
    valueDescription: "",
    type: propertyTypes.DATE,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  edizioneDIPAggProperty: {
    code: codes.edizioneDIPAggProperty,
    name: "Edizione DIP aggiuntivo",
    description: "",
    order: 12,
    value: "",
    values: [],
    dateValue: null,
    valueDescription: "",
    type: propertyTypes.DATE,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  tipologiaPremioProperty: {
    code: codes.tipologiaPremioProperty,
    name: "Tipologia premio",
    description: "",
    order: 13,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  durataContrattoProperty: {
    code: codes.durataContrattoProperty,
    name: "Durata contrattuale",
    description: "",
    order: 14,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  durataPianoPagamentoPremiProperty: {
    code: codes.durataPianoPagamentoPremiProperty,
    name: "Durata piano pagamento premi",
    description: "",
    order: 15,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  importoMinPremioUnicoProperty: {
    code: codes.importoMinPremioUnicoProperty,
    name: "Importo minimo del premio unico",
    description: "",
    order: 16,
    value: "",
    valueSign: "",
    valueSignLeft: true,
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  importoMaxPremioUnicoProperty: {
    code: codes.importoMaxPremioUnicoProperty,
    name: "Importo massimo del premio unico",
    description: "",
    order: 17,
    value: "",
    valueSign: "",
    valueSignLeft: true,
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  importoMinPremioRicAnnuoProperty: {
    code: codes.importoMinPremioRicAnnuoProperty,
    name: "Importo minimo del premio ricorrente (annuo)",
    description: "",
    order: 18,
    value: "",
    valueSign: "",
    valueSignLeft: true,
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  importoMaxPremioRicAnnuoProperty: {
    code: codes.importoMaxPremioRicAnnuoProperty,
    name: "Importo massimo del premio ricorrente (annuo)",
    description: "",
    order: 19,
    value: "",
    valueSign: "",
    valueSignLeft: true,
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  targetMarketProperty: {
    code: codes.targetMarketProperty,
    name: "Target Market",
    description: "",
    order: 20,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  orizzonteTemporaleSuggeritoProperty: {
    code: codes.orizzonteTemporaleSuggeritoProperty,
    name: "Orizzonte temporale suggerito",
    description: "",
    order: 21,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Indicatori KID",
    sectionIndex: 3
  },
  indicatoreSinteticoRischioProperty: {
    code: codes.indicatoreSinteticoRischioProperty,
    name: "Indicatore sintetico di rischio",
    description: "",
    order: 22,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Indicatori KID",
    sectionIndex: 3
  },
  reductionInYieldCostiIngressoProperty: {
    code: codes.reductionInYieldCostiIngressoProperty,
    name: "Reduction in Yield - Costi di ingresso",
    description: "",
    order: 23,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Indicatori KID",
    sectionIndex: 3
  },
  reductionInYieldCostiUscitaProperty: {
    code: codes.reductionInYieldCostiUscitaProperty,
    name: "Reduction in Yield - Costi di uscita",
    description: "",
    order: 24,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Indicatori KID",
    sectionIndex: 3
  },
  reductionInYieldCostiCorrentiProperty: {
    code: codes.reductionInYieldCostiCorrentiProperty,
    name: "Reduction in Yield - Costi correnti",
    description: "",
    order: 25,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Indicatori KID",
    sectionIndex: 3
  },
  assetAllocationProperty: {
    code: codes.assetAllocationProperty,
    name: "Asset Allocation",
    description: "",
    order: 26,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  invMinGestioneSeparataProperty: {
    code: codes.invMinGestioneSeparataProperty,
    name: "Investimento minimo in Gestione Separata",
    description: "",
    order: 27,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  invMaxGestioneSeparataProperty: {
    code: codes.invMaxGestioneSeparataProperty,
    name: "Investimento massimo in Gestione Separata",
    description: "",
    order: 28,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  gestioneSeparataProperty: {
    code: codes.gestioneSeparataProperty,
    name: "Gestione Separata",
    description: "",
    order: 29,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  rendimentoGestioneSeparataProperty: {
    code: codes.rendimentoGestioneSeparataProperty,
    name: "Rendimento Gestione Separata",
    description: "",
    order: 30,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  rendMinGarantitoProperty: {
    code: codes.rendMinGarantitoProperty,
    name: "Rendimento minimo garantito",
    description: "",
    order: 31,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  rendMinGarantitoMisuraProperty: {
    code: codes.rendMinGarantitoMisuraProperty,
    name: "Rendimento minimo garantito - Misura",
    description: "",
    order: 32,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  presenzaConsolidamentoAnnuoRivalutazioniContrattualiProperty: {
    code: codes.presenzaConsolidamentoAnnuoRivalutazioniContrattualiProperty,
    name: "Presenza consolidamento annuo delle rivalutazioni contrattuali",
    description: "",
    order: 33,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  consolidamentoAnnuoRivalutazioniContrattualiProperty: {
    code: codes.consolidamentoAnnuoRivalutazioniContrattualiProperty,
    name: "Consolidamento annuo delle rivalutazioni contrattuali",
    description: "",
    order: 34,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  fondoUtiliProperty: {
    code: codes.fondoUtiliProperty,
    name: "Fondo Utili",
    description: "",
    order: 35,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  invMinRamoIIIProperty: {
    code: codes.invMinRamoIIIProperty,
    name: "Investimento minimo in Ramo III",
    description: "",
    order: 36,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  invMaxRamoIIIProperty: {
    code: codes.invMaxRamoIIIProperty,
    name: "Investimento massimo in Ramo III",
    description: "",
    order: 37,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  numFondiInterniProperty: {
    code: codes.numFondiInterniProperty,
    name: "Numero Fondi Interni",
    description: "",
    order: 38,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  tipologiaFondiInterniProperty: {
    code: codes.tipologiaFondiInterniProperty,
    name: "Tipologia Fondi Interni",
    description: "",
    order: 39,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  numOICRETFProperty: {
    code: codes.numOICRETFProperty,
    name: "Numero OICR/ETF",
    description: "",
    order: 40,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  presenzaProtezioneCapitaleProperty: {
    code: codes.presenzaProtezioneCapitaleProperty,
    name: "Presenza protezione del capitale",
    description: "",
    order: 41,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  protezioneCapitaleProperty: {
    code: codes.protezioneCapitaleProperty,
    name: "Protezione del capitale",
    description: "",
    order: 42,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  opzioniContrattualiTipologiaProperty: {
    code: codes.opzioniContrattualiTipologiaProperty,
    name: "Opzioni contrattuali - Tipologia",
    description: "",
    order: 43,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Opzioni contrattuali",
    sectionIndex: 5
  },
  cedolaProperty: {
    code: codes.cedolaProperty,
    name: "Cedola",
    description: "",
    order: 44,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Opzioni contrattuali",
    sectionIndex: 5
  },
  decumuloProperty: {
    code: codes.decumuloProperty,
    name: "Decumulo",
    description: "",
    order: 45,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Opzioni contrattuali",
    sectionIndex: 5
  },
  renditaProperty: {
    code: codes.renditaProperty,
    name: "Rendita",
    description: "",
    order: 46,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Opzioni contrattuali",
    sectionIndex: 5
  },
  stopLossProperty: {
    code: codes.stopLossProperty,
    name: "Stop Loss",
    description: "",
    order: 47,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Opzioni contrattuali",
    sectionIndex: 5
  },
  takeProfitProperty: {
    code: codes.takeProfitProperty,
    name: "Take Profit",
    description: "",
    order: 48,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Opzioni contrattuali",
    sectionIndex: 5
  },
  progressiveInvestmentProperty: {
    code: codes.progressiveInvestmentProperty,
    name: "Progressive Investment",
    description: "",
    order: 49,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Opzioni contrattuali",
    sectionIndex: 5
  },
  automaticRebalanceProperty: {
    code: codes.automaticRebalanceProperty,
    name: "Automatic Rebalance",
    description: "",
    order: 50,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Opzioni contrattuali",
    sectionIndex: 5
  },
  downtrendOpportunityProperty: {
    code: codes.downtrendOpportunityProperty,
    name: "Downtrend Opportunity",
    description: "",
    order: 51,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Opzioni contrattuali",
    sectionIndex: 5
  },
  lifeCycleProperty: {
    code: codes.lifeCycleProperty,
    name: "Life Cycle",
    description: "",
    order: 52,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Opzioni contrattuali",
    sectionIndex: 5
  },
  altreOpzioniContrattualiProperty: {
    code: codes.altreOpzioniContrattualiProperty,
    name: "Altre opzioni contrattuali",
    description: "",
    order: 53,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Opzioni contrattuali",
    sectionIndex: 5
  },
  garanzieAssicurativeTipologiaProperty: {
    code: codes.garanzieAssicurativeTipologiaProperty,
    name: "Garanzie assicurative - Tipologia",
    description: "",
    order: 54,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  maggiorazioneCasoMorteStandardProperty: {
    code: codes.maggiorazioneCasoMorteStandardProperty,
    name: "Maggiorazione caso morte standard",
    description: "",
    order: 55,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  maggiorazioneCasoMorteStandardPrestazioneProperty: {
    code: codes.maggiorazioneCasoMorteStandardPrestazioneProperty,
    name: "Maggiorazione caso morte standard - Prestazione",
    description: "",
    order: 56,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [
      {
        value: "",
        showSign: true,
        valueSign: "",
        valueSignReadonly: false,
        valueSignLeft: false,
        showLabel: false,
        valueLabel: "",
        valueLabelReadonly: false,
        valueLabelFix: false
      }
    ],
    type: propertyTypes.STRING_LIST,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  maggiorazioneCasoMortePerInfortunioProperty: {
    code: codes.maggiorazioneCasoMortePerInfortunioProperty,
    name: "Maggiorazione caso morte per infortunio",
    description: "",
    order: 57,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  maggiorazioneCasoMortePerInfortunioPrestazioneProperty: {
    code: codes.maggiorazioneCasoMortePerInfortunioPrestazioneProperty,
    name: "Maggiorazione caso morte per infortunio - Prestazione",
    description: "",
    order: 58,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  maggiorazioneCasoMortePerIncidenteStradaleProperty: {
    code: codes.maggiorazioneCasoMortePerIncidenteStradaleProperty,
    name: "Maggiorazione caso morte per incidente stradale",
    description: "",
    order: 59,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  maggiorazioneCasoMortePerIncidenteStradalePrestazioneProperty: {
    code: codes.maggiorazioneCasoMortePerIncidenteStradalePrestazioneProperty,
    name: "Maggiorazione caso morte per incidente stradale - Prestazione",
    description: "",
    order: 60,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  maggiorazioneCasoMortePerMinusvalenzaProperty: {
    code: codes.maggiorazioneCasoMortePerMinusvalenzaProperty,
    name: "Maggiorazione caso morte per minusvalenza",
    description: "",
    order: 61,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  maggiorazioneCasoMortePerMinusvalenzaPrestazioneProperty: {
    code: codes.maggiorazioneCasoMortePerMinusvalenzaPrestazioneProperty,
    name: "Maggiorazione caso morte per minusvalenza - Prestazione",
    description: "",
    order: 62,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  TCMStandAloneProperty: {
    code: codes.TCMStandAloneProperty,
    name: "TCM stand alone",
    description: "",
    order: 63,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  TCMStandAlonePrestazioneProperty: {
    code: codes.TCMStandAlonePrestazioneProperty,
    name: "TCM stand alone - Prestazione",
    description: "",
    order: 64,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  longTermCareProperty: {
    code: codes.longTermCareProperty,
    name: "Long Term Care",
    description: "",
    order: 65,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  longTermCarePrestazioneProperty: {
    code: codes.longTermCarePrestazioneProperty,
    name: "Long Term Care - Prestazione",
    description: "",
    order: 66,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  dreadDiseaseProperty: {
    code: codes.dreadDiseaseProperty,
    name: "Dread Disease",
    description: "",
    order: 67,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  dreadDiseasePrestazioneProperty: {
    code: codes.dreadDiseasePrestazioneProperty,
    name: "Dread Disease - Prestazione",
    description: "",
    order: 68,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  invaliditaInabilitaProperty: {
    code: codes.invaliditaInabilitaProperty,
    name: "Invalidità/Inabilità",
    description: "",
    order: 69,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  invaliditaInabilitaPrestazioneProperty: {
    code: codes.invaliditaInabilitaPrestazioneProperty,
    name: "Invalidità/Inabilità - Prestazione",
    description: "",
    order: 70,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  altreGaranzieAssicurativeProperty: {
    code: codes.altreGaranzieAssicurativeProperty,
    name: "Altre garanzie assicurative",
    description: "",
    order: 71,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  tipologiaBonusIngressoProperty: {
    code: codes.tipologiaBonusIngressoProperty,
    name: "Tipologia bonus d'ingresso",
    description: "",
    order: 72,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Bonus",
    sectionIndex: 7
  },
  bonusIngressoProperty: {
    code: codes.bonusIngressoProperty,
    name: "Bonus d'ingresso",
    description: "",
    order: 73,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        toValueOperator: "",
        showValue: true,
        value: "",
        valueSign: "",
        valueSignLeft: false,
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Bonus",
    sectionIndex: 7
  },
  tipologiaBonusFedeltaProperty: {
    code: codes.tipologiaBonusFedeltaProperty,
    name: "Tipologia bonus fedeltà",
    description: "",
    order: 74,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Bonus",
    sectionIndex: 7
  },
  bonusFedeltaProperty: {
    code: codes.bonusFedeltaProperty,
    name: "Bonus fedeltà",
    description: "",
    order: 75,
    value: "",
    values: [],
    valueDescription: "",
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        showValue: false,
        toValueOperator: "",
        value: "",
        valueSign: "",
        valueSignLeft: false,
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Bonus",
    sectionIndex: 7
  },
  speseEmissioneProperty: {
    code: codes.speseEmissioneProperty,
    name: "Spese di emissione",
    description: "",
    order: 76,
    value: "",
    valueSign: "",
    valueSignLeft: true,
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 8
  },
  tipologiaCaricamentoPICProperty: {
    code: codes.tipologiaCaricamentoPICProperty,
    name: "Tipologia Caricamento PIC (%)",
    description: "",
    order: 77,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 8
  },
  caricamentoPICProperty: {
    code: codes.caricamentoPICProperty,
    name: "Caricamento PIC (%)",
    description: "",
    order: 78,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        showValue: false,
        toValueOperator: "",
        value: "",
        valueSign: "",
        valueSignLeft: false,
        rangeValuesFlex: [
          {
            order: 0,
            label: "",
            from: "",
            fromSign: "",
            fromSignLeft: false,
            fromToOperator: "",
            to: "",
            toSign: "",
            toSignLeft: false,
            showValue: false,
            toValueOperator: "",
            value: "",
            valueSign: "",
            valueSignLeft: false,
          }
        ]
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Costi",
    sectionIndex: 8
  },
  tipologiaCaricamentoPACProperty: {
    code: codes.tipologiaCaricamentoPACProperty,
    name: "Tipologia Caricamento PAC (%)",
    description: "",
    order: 79,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 8
  },
  caricamentoPACProperty: {
    code: codes.caricamentoPACProperty,
    name: "Caricamento PAC (%)",
    description: "",
    order: 80,
    value: "",
    values: [],
    valueSign: "",
    valueDescription: "",
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        showValue: false,
        toValueOperator: "",
        value: "",
        valueSign: "",
        valueSignLeft: false,
        rangeValuesFlex: [
          {
            order: 0,
            label: "",
            from: "",
            fromSign: "",
            fromSignLeft: false,
            fromToOperator: "",
            to: "",
            toSign: "",
            toSignLeft: false,
            showValue: false,
            toValueOperator: "",
            value: "",
            valueSign: "",
            valueSignLeft: false,
          }
        ]
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Costi",
    sectionIndex: 8
  },
  caricamentoProperty: {
    code: codes.caricamentoProperty,
    name: "Caricamento (€)",
    description: "",
    order: 81,
    value: "",
    valueSign: "",
    valueSignLeft: true,
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 8
  },
  tipologiaCommissioneGestioneSeparataProperty: {
    code: codes.tipologiaCommissioneGestioneSeparataProperty,
    name: "Tipologia commissione Gestione Separata",
    description: "",
    order: 82,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 8
  },
  commissioneGestioneSeparataProperty: {
    code: codes.commissioneGestioneSeparataProperty,
    name: "Commissione Gestione Separata",
    description: "",
    order: 83,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    stringList: [
      {
        value: "",
        showSign: false,
        valueSign: "",
        valueSignReadonly: false,
        valueSignLeft: false,
        showLabel: false,
        valueLabel: "",
        valueLabelReadonly: false,
        valueLabelFix: true
      }
    ],
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        showValue: false,
        toValueOperator: "",
        value: "",
        valueSign: "",
        valueSignLeft: false,
        rangeValuesFlex: [
          {
            order: 0,
            label: "",
            from: "",
            fromSign: "",
            fromSignLeft: false,
            fromToOperator: "",
            to: "",
            toSign: "",
            toSignLeft: false,
            showValue: false,
            toValueOperator: "",
            value: "",
            valueSign: "",
            valueSignLeft: false,
          }
        ]
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Costi",
    sectionIndex: 8
  },
  tipologiaCommissioneFondiInterniProperty: {
    code: codes.tipologiaCommissioneFondiInterniProperty,
    name: "Tipologia commissione Fondi Interni",
    description: "",
    order: 84,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 8
  },
  commissioneFondiInterniAzionariProperty: {
    code: codes.commissioneFondiInterniAzionariProperty,
    name: "Commissione Fondi Interni Azionari",
    description: "",
    order: 85,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        showValue: false,
        toValueOperator: "",
        value: "",
        valueSign: "",
        valueSignLeft: false,
        rangeValuesFlex: [
          {
            order: 0,
            label: "",
            from: "",
            fromSign: "",
            fromSignLeft: false,
            fromToOperator: "",
            to: "",
            toSign: "",
            toSignLeft: false,
            showValue: false,
            toValueOperator: "",
            value: "",
            valueSign: "",
            valueSignLeft: false,
          }
        ]
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Costi",
    sectionIndex: 8
  },
  commissioneFondiInterniObbligazionariProperty: {
    code: codes.commissioneFondiInterniObbligazionariProperty,
    name: "Commissione Fondi Interni Obbligazionari",
    description: "",
    order: 86,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        showValue: false,
        toValueOperator: "",
        value: "",
        valueSign: "",
        valueSignLeft: false,
        rangeValuesFlex: [
          {
            order: 0,
            label: "",
            from: "",
            fromSign: "",
            fromSignLeft: false,
            fromToOperator: "",
            to: "",
            toSign: "",
            toSignLeft: false,
            showValue: false,
            toValueOperator: "",
            value: "",
            valueSign: "",
            valueSignLeft: false,
          }
        ]
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Costi",
    sectionIndex: 8
  },
  commissioneFondiInterniBilanciatiProperty: {
    code: codes.commissioneFondiInterniBilanciatiProperty,
    name: "Commissione Fondi Interni Bilanciati",
    description: "",
    order: 87,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        showValue: false,
        toValueOperator: "",
        value: "",
        valueSign: "",
        valueSignLeft: false,
        rangeValuesFlex: [
          {
            order: 0,
            label: "",
            from: "",
            fromSign: "",
            fromSignLeft: false,
            fromToOperator: "",
            to: "",
            toSign: "",
            toSignLeft: false,
            showValue: false,
            toValueOperator: "",
            value: "",
            valueSign: "",
            valueSignLeft: false,
          }
        ]
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Costi",
    sectionIndex: 8
  },
  commissioneFondiInterniFlessibiliProperty: {
    code: codes.commissioneFondiInterniFlessibiliProperty,
    name: "Commissione Fondi Interni Flessibili",
    description: "",
    order: 88,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        showValue: false,
        toValueOperator: "",
        value: "",
        valueSign: "",
        valueSignLeft: false,
        rangeValuesFlex: [
          {
            order: 0,
            label: "",
            from: "",
            fromSign: "",
            fromSignLeft: false,
            fromToOperator: "",
            to: "",
            toSign: "",
            toSignLeft: false,
            showValue: false,
            toValueOperator: "",
            value: "",
            valueSign: "",
            valueSignLeft: false,
          }
        ]
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Costi",
    sectionIndex: 8
  },
  commissioneFondiInterniMonetariProperty: {
    code: codes.commissioneFondiInterniMonetariProperty,
    name: "Commissione Fondi Interni Monetari",
    description: "",
    order: 89,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        showValue: false,
        toValueOperator: "",
        value: "",
        valueSign: "",
        valueSignLeft: false,
        rangeValuesFlex: [
          {
            order: 0,
            label: "",
            from: "",
            fromSign: "",
            fromSignLeft: false,
            fromToOperator: "",
            to: "",
            toSign: "",
            toSignLeft: false,
            showValue: false,
            toValueOperator: "",
            value: "",
            valueSign: "",
            valueSignLeft: false,
          }
        ]
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Costi",
    sectionIndex: 8
  },
  commissioneSottostantiFondiInterniProperty: {
    code: codes.commissioneSottostantiFondiInterniProperty,
    name: "Commissione sottostanti Fondi Interni",
    description: "",
    order: 90,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Costi",
    sectionIndex: 8
  },
  tipologiaSpeseGestionePolizzaOICRETFProperty: {
    code: codes.tipologiaSpeseGestionePolizzaOICRETFProperty,
    name: "Tipologia spese gestione polizza (OICR/ETF)",
    description: "",
    order: 91,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 8
  },
  speseGestionePolizzaOICRETFAzionariProperty: {
    code: codes.speseGestionePolizzaOICRETFAzionariProperty,
    name: "Spese gestione polizza OICR/ETF Azionari",
    description: "",
    order: 92,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        showValue: false,
        toValueOperator: "",
        value: "",
        valueSign: "",
        valueSignLeft: false,
        rangeValuesFlex: [
          {
            order: 0,
            label: "",
            from: "",
            fromSign: "",
            fromSignLeft: false,
            fromToOperator: "",
            to: "",
            toSign: "",
            toSignLeft: false,
            showValue: false,
            toValueOperator: "",
            value: "",
            valueSign: "",
            valueSignLeft: false,
          }
        ]
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Costi",
    sectionIndex: 8
  },
  speseGestionePolizzaOICRETFObbligazionariProperty: {
    code: codes.speseGestionePolizzaOICRETFObbligazionariProperty,
    name: "Spese gestione polizza OICR/ETF Obbligazionari",
    description: "",
    order: 93,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        showValue: false,
        toValueOperator: "",
        value: "",
        valueSign: "",
        valueSignLeft: false,
        rangeValuesFlex: [
          {
            order: 0,
            label: "",
            from: "",
            fromSign: "",
            fromSignLeft: false,
            fromToOperator: "",
            to: "",
            toSign: "",
            toSignLeft: false,
            showValue: false,
            toValueOperator: "",
            value: "",
            valueSign: "",
            valueSignLeft: false,
          }
        ]
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Costi",
    sectionIndex: 8
  },
  speseGestionePolizzaOICRETFBilanciatiProperty: {
    code: codes.speseGestionePolizzaOICRETFBilanciatiProperty,
    name: "Spese gestione polizza OICR/ETF Bilanciati",
    description: "",
    order: 94,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        showValue: false,
        toValueOperator: "",
        value: "",
        valueSign: "",
        valueSignLeft: false,
        rangeValuesFlex: [
          {
            order: 0,
            label: "",
            from: "",
            fromSign: "",
            fromSignLeft: false,
            fromToOperator: "",
            to: "",
            toSign: "",
            toSignLeft: false,
            showValue: false,
            toValueOperator: "",
            value: "",
            valueSign: "",
            valueSignLeft: false,
          }
        ]
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Costi",
    sectionIndex: 8
  },
  speseGestionePolizzaOICRETFFlessibiliProperty: {
    code: codes.speseGestionePolizzaOICRETFFlessibiliProperty,
    name: "Spese gestione polizza OICR/ETF Flessibili",
    description: "",
    order: 95,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        showValue: false,
        toValueOperator: "",
        value: "",
        valueSign: "",
        valueSignLeft: false,
        rangeValuesFlex: [
          {
            order: 0,
            label: "",
            from: "",
            fromSign: "",
            fromSignLeft: false,
            fromToOperator: "",
            to: "",
            toSign: "",
            toSignLeft: false,
            showValue: false,
            toValueOperator: "",
            value: "",
            valueSign: "",
            valueSignLeft: false,
          }
        ]
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Costi",
    sectionIndex: 8
  },
  speseGestionePolizzaOICRETFMonetariProperty: {
    code: codes.speseGestionePolizzaOICRETFMonetariProperty,
    name: "Spese gestione polizza OICR/ETF Monetari",
    description: "",
    order: 96,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        showValue: false,
        toValueOperator: "",
        value: "",
        valueSign: "",
        valueSignLeft: false,
        rangeValuesFlex: [
          {
            order: 0,
            label: "",
            from: "",
            fromSign: "",
            fromSignLeft: false,
            fromToOperator: "",
            to: "",
            toSign: "",
            toSignLeft: false,
            showValue: false,
            toValueOperator: "",
            value: "",
            valueSign: "",
            valueSignLeft: false,
          }
        ]
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Costi",
    sectionIndex: 8
  },
  commissioneOICRETFProperty: {
    code: codes.commissioneOICRETFProperty,
    name: "Commissione OICR/ETF",
    description: "",
    order: 97,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Costi",
    sectionIndex: 8
  },
  applicazioneCommissioniOverperformanceProperty: {
    code: codes.applicazioneCommissioniOverperformanceProperty,
    name: "Applicazione commissioni di overperformance",
    description: "",
    order: 98,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 8
  },
  commissioniOverperformanceProperty: {
    code: codes.commissioniOverperformanceProperty,
    name: "Commissioni di overperformance",
    description: "",
    order: 99,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 8
  },
  costoMaggiorazioneCasoMorteStandardProperty: {
    code: codes.costoMaggiorazioneCasoMorteStandardProperty,
    name: "Costo maggiorazione caso morte standard (%)",
    description: "",
    order: 100,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 8
  },
  riscattoProperty: {
    code: codes.riscattoProperty,
    name: "Riscatto",
    description: "",
    order: 101,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 8
  },
  applicazioneCommissioniUscitaProperty: {
    code: codes.applicazioneCommissioniUscitaProperty,
    name: "Applicazione commissioni di uscita",
    description: "",
    order: 102,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 8
  },
  commissioniUscitaProperty: {
    code: codes.commissioniUscitaProperty,
    name: "Commissioni di uscita (%)",
    description: "",
    order: 103,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Costi",
    sectionIndex: 8
  },
  altriCostiProperty: {
    code: codes.altriCostiProperty,
    name: "Altri costi",
    description: "",
    order: 104,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 8
  },
  retrocessioneCaricamentoProperty: {
    code: codes.retrocessioneCaricamentoProperty,
    name: "Retrocessione Caricamento",
    description: "",
    order: 105,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Retrocessione alla distribuzione",
    sectionIndex: 9
  },
  retrocessioneGestioneSeparataProperty: {
    code: codes.retrocessioneGestioneSeparataProperty,
    name: "Retrocessione Gestione Separata",
    description: "",
    order: 106,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Retrocessione alla distribuzione",
    sectionIndex: 9
  },
  retrocessioneRamoIIIProperty: {
    code: codes.retrocessioneRamoIIIProperty,
    name: "Retrocessione Ramo III",
    description: "",
    order: 107,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Retrocessione alla distribuzione",
    sectionIndex: 9
  },
  sostenibilitaProperty:{
    code: codes.sostenibilitaProperty,
    name: "Polizza sostenibile ai sensi degli Artt. 8-9 SFDR", 
    description: "",
    order: 108,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Sostenibilità",
    subsectionName: "Sostenibilità",
    sectionIndex: 10
  },
  ramoISFDRProperty:{
    code: codes.ramoISFDRProperty,
    name: "SFDR Gestione Separata", 
    description: "",
    order: 109,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Sostenibilità",
    subsectionName: "Ramo I",
    sectionIndex: 10
  },
  ramoITassonomiaUEProperty:{
    code: codes.ramoITassonomiaUEProperty,
    name: "Tassonomia UE Gestione Separata", 
    description: "",
    order: 110,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Sostenibilità",
    subsectionName: "Ramo I",
    sectionIndex: 10
  },
  ramoIAllocazioneAttiviProperty:{
    code: codes.ramoIAllocazioneAttiviProperty,
    name: "Allocazione attivi Gestione Separata", 
    description: "",
    order: 111,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Sostenibilità",
    subsectionName: "Ramo I",
    sectionIndex: 10
  },
  ramoIPAIProperty:{
    code: codes.ramoIPAIProperty,
    name: "PAI Gestione Separata", 
    description: "",
    order: 112,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Sostenibilità",
    subsectionName: "Ramo I",
    sectionIndex: 10
  },
  ramoIIIPresenzaFondiInterniArt8SFDRProperty:{
    code: codes.ramoIIIPresenzaFondiInterniArt8SFDRProperty,
    name: "Presenza Fondi Interni Art. 8 SFDR", 
    description: "",
    order: 113,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Sostenibilità",
    subsectionName: "Ramo III",
    sectionIndex: 10
  },
  ramoIIINumFondiInterniArt8SFDRProperty:{
    code: codes.ramoIIINumFondiInterniArt8SFDRProperty,
    name: "N° Fondi Interni Art. 8 SFDR", 
    description: "",
    order: 114,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Sostenibilità",
    subsectionName: "Ramo III",
    sectionIndex: 10
  },
  ramoIIIFondiInterniArt8SFDRPercProperty:{
    code: codes.ramoIIIFondiInterniArt8SFDRPercProperty,
    name: "Fondi Interni Art. 8 SFDR (%)", 
    description: "",
    order: 115,
    value: "",
    valueSign: "%",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Sostenibilità",
    subsectionName: "Ramo III",
    sectionIndex: 10
  },
  ramoIIITassonomiaUEFondiInterniArt8Property:{
    code: codes.ramoIIITassonomiaUEFondiInterniArt8Property,
    name: "Tassonomia UE Fondi Interni Art. 8", 
    description: "",
    order: 116,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Sostenibilità",
    subsectionName: "Ramo III",
    sectionIndex: 10
  },
  ramoIIIAllocazioneAttiviFondiInterniArt8Property:{
    code: codes.ramoIIIAllocazioneAttiviFondiInterniArt8Property,
    name: "Allocazione attivi Fondi Interni Art. 8", 
    description: "",
    order: 117,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Sostenibilità",
    subsectionName: "Ramo III",
    sectionIndex: 10
  },
  ramoIIIPresenzaFondiInterniArt9SFDRProperty:{
    code: codes.ramoIIIPresenzaFondiInterniArt9SFDRProperty,
    name: "Presenza Fondi Interni Art. 9 SFDR", 
    description: "",
    order: 118,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Sostenibilità",
    subsectionName: "Ramo III",
    sectionIndex: 10
  },
  ramoIIINumFondiInterniArt9SFDRProperty:{
    code: codes.ramoIIINumFondiInterniArt9SFDRProperty,
    name: "N° Fondi Interni Art. 9 SFDR", 
    description: "",
    order: 119,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Sostenibilità",
    subsectionName: "Ramo III",
    sectionIndex: 10
  },
  ramoIIIFondiInterniArt9SFDRPercProperty:{
    code: codes.ramoIIIFondiInterniArt9SFDRPercProperty,
    name: "Fondi Interni Art. 9 SFDR (%)", 
    description: "",
    order: 120,
    value: "",
    valueSign: "%",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Sostenibilità",
    subsectionName: "Ramo III",
    sectionIndex: 10
  },
  ramoIIITassonomiaUEFondiInterniArt9Property:{
    code: codes.ramoIIITassonomiaUEFondiInterniArt9Property,
    name: "Tassonomia UE Fondi Interni Art. 9", 
    description: "",
    order: 121,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Sostenibilità",
    subsectionName: "Ramo III",
    sectionIndex: 10
  },
  ramoIIIAllocazioneAttiviFondiInterniArt9Property:{
    code: codes.ramoIIIAllocazioneAttiviFondiInterniArt9Property,
    name: "Allocazione attivi Fondi Interni Art. 9", 
    description: "",
    order: 122,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Sostenibilità",
    subsectionName: "Ramo III",
    sectionIndex: 10
  },
  ramoIIIPAIFondiInterniProperty:{
    code: codes.ramoIIIPAIFondiInterniProperty,
    name: "PAI Fondi Interni", 
    description: "",
    order: 123,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Sostenibilità",
    subsectionName: "Ramo III",
    sectionIndex: 10
  },
  ramoIIIPresenzaOICRETFArt8SFDRProperty:{
    code: codes.ramoIIIPresenzaOICRETFArt8SFDRProperty,
    name: "Presenza OICR/ETF Art. 8 SFDR", 
    description: "",
    order: 124,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Sostenibilità",
    subsectionName: "Ramo III",
    sectionIndex: 10
  },
  ramoIIINumOICRETFArt8SFDRProperty:{
    code: codes.ramoIIINumOICRETFArt8SFDRProperty,
    name: "N° OICR/ETF Art. 8 SFDR", 
    description: "",
    order: 125,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Sostenibilità",
    subsectionName: "Ramo III",
    sectionIndex: 10
  },
  ramoIIIOICRETFArt8SFDRPercProperty:{
    code: codes.ramoIIIOICRETFArt8SFDRPercProperty,
    name: "OICR/ETF Art. 8 SFDR (%)", 
    description: "",
    order: 126,
    value: "",
    valueSign: "%",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Sostenibilità",
    subsectionName: "Ramo III",
    sectionIndex: 10
  },
  ramoIIITassonomiaUEOICRETFArt8Property:{
    code: codes.ramoIIITassonomiaUEOICRETFArt8Property,
    name: "Tassonomia UE OICR/ETF Art. 8", 
    description: "",
    order: 127,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Sostenibilità",
    subsectionName: "Ramo III",
    sectionIndex: 10
  },
  ramoIIIPresenzaOICRETFArt9SFDRProperty:{
    code: codes.ramoIIIPresenzaOICRETFArt9SFDRProperty,
    name: "Presenza OICR/ETF Art. 9 SFDR", 
    description: "",
    order: 128,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Sostenibilità",
    subsectionName: "Ramo III",
    sectionIndex: 10
  },
  ramoIIINumOICRETFArt9SFDRProperty:{
    code: codes.ramoIIINumOICRETFArt9SFDRProperty,
    name: "N° OICR/ETF Art. 9 SFDR", 
    description: "",
    order: 129,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Sostenibilità",
    subsectionName: "Ramo III",
    sectionIndex: 10
  },
  ramoIIIOICRETFArt9SFDRPercProperty:{
    code: codes.ramoIIIOICRETFArt9SFDRPercProperty,
    name: "OICR/ETF Art. 9 SFDR (%)", 
    description: "",
    order: 130,
    value: "",
    valueSign: "%",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Sostenibilità",
    subsectionName: "Ramo III",
    sectionIndex: 10
  },
  ramoIIITassonomiaUEOICRETFArt9Property:{
    code: codes.ramoIIITassonomiaUEOICRETFArt9Property,
    name: "Tassonomia UE OICR/ETF Art. 9", 
    description: "",
    order: 131,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Sostenibilità",
    subsectionName: "Ramo III",
    sectionIndex: 10
  },
  ramoIIIPAIOICRETFProperty:{
    code: codes.ramoIIIPAIOICRETFProperty,
    name: "PAI OICR/ETF", 
    description: "",
    order: 132,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Sostenibilità",
    subsectionName: "Ramo III",
    sectionIndex: 10
  },
  noteProperty: {
    code: codes.noteProperty,
    name: "Note",
    description: "",
    order: 133,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Note",
    sectionIndex: 11
  },
};

export {codes};
export default properties;
